import React, { useState, useEffect } from 'react';
import IntroSection from './sections/IntroSection';
import ProjectStage from './ProjectStage';
import GatewaySection from './sections/GatewaySection';
import { showcaseProjects, sectionsList } from '../../data/projects';
import { scrollProgress } from '../../context/ScrollContext';

const HTMLOverlay = () => {
  const [currentSectionIndex, setCurrentSectionIndex] = useState(0);

  useEffect(() => {
    let frameId;
    const checkActiveSection = () => {
      const t = scrollProgress.value || 0;
      for (let i = sectionsList.length - 1; i >= 0; i--) {
        if (t >= sectionsList[i].start) {
          setCurrentSectionIndex(i);
          break;
        }
      }
      frameId = requestAnimationFrame(checkActiveSection);
    };

    frameId = requestAnimationFrame(checkActiveSection);
    return () => cancelAnimationFrame(frameId);
  }, []);

  return (
    <div
      className="html-overlay"
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '920vh',
        pointerEvents: 'none',
        zIndex: 10,
      }}
    >
      {/* 0. Fixed Intro Stage */}
      <div
        style={{
          position: 'fixed',
          inset: 0,
          opacity: currentSectionIndex === 0 ? 1 : 0,
          transform: currentSectionIndex === 0 ? 'scale(1)' : 'scale(0.97)',
          transition: 'opacity 0.4s ease, transform 0.4s ease',
          pointerEvents: currentSectionIndex === 0 ? 'auto' : 'none',
          zIndex: 15,
        }}
      >
        <IntroSection />
      </div>

      {/* 1-6. Fixed Single-Project Stages */}
      {showcaseProjects.map((project, idx) => {
        const isThisProjectActive = currentSectionIndex === idx + 1;
        return (
          <ProjectStage
            key={project.id}
            project={project}
            isVisible={isThisProjectActive}
          />
        );
      })}

      {/* 7. Fixed Gateway Finale Stage */}
      <div
        style={{
          position: 'fixed',
          inset: 0,
          opacity: currentSectionIndex === 7 ? 1 : 0,
          transform: currentSectionIndex === 7 ? 'scale(1)' : 'scale(0.97)',
          transition: 'opacity 0.4s ease, transform 0.4s ease',
          pointerEvents: currentSectionIndex === 7 ? 'auto' : 'none',
          zIndex: 15,
        }}
      >
        <GatewaySection topOffset="0vh" />
      </div>
    </div>
  );
};

export default HTMLOverlay;
